export default __webpack_public_path__ + "static/media/prago.85af3e7e.jpg";